import moment from 'moment';

const getConsultDate = () => moment().add(1, 'days').format('YYYY.MM.DD');

const getDefaultConsultTime = () => {
  const times = moment().format('HH:mm').split(':');
  let hour = times[0] * 1;
  let min = times[1] * 1;
  let date = moment().format('YYYY.MM.DD');

  if (min > 40 && min < 60) {
    hour = hour + 1;
    min = '00';
  }
  
  if (min > 0 && min < 20) {
    min = '20';
  }

  if (min > 20 && min < 40) {
    min = '40';
  }
  
  if (hour > 18) {
    hour = '09';
    min = '00';
    date = getConsultDate();
  }

  if (hour === 18 && min !== '00') {
    date = getConsultDate();
    hour = '09';
    min = '00';
  }

  if (hour < 10) {
    if (hour < 9) {
      min = '00';
    }

    hour = '09';
  }

  return {
    time: hour + ':' + min,
    date
  }
}

export default {
  install(Vue) {
    Vue.prototype.$getDefaultConsultTime = getDefaultConsultTime;
  }
}